var CamelCase = require('camelcase');

var CALLBACK_QUEUE = [];

function callback (component, role, hook) {
  var cb = component.props[CamelCase.apply(null, ['on', hook, role])];
  if (!cb) return;
  var args = Array.prototype.slice.call(arguments, 3);
  return cb.apply(component, args);
}

function addCallback () {
  var args = arguments;
  CALLBACK_QUEUE.push(function () {
    callback.apply(null, args);
  });
}

function flushCallbacks () {
  while (CALLBACK_QUEUE.length) {
    CALLBACK_QUEUE.pop()();
  }
}

module.exports = {
  call: callback,
  flush: flushCallbacks,
  add: addCallback
};



// WEBPACK FOOTER //
// ./src/app/components/callbacks.js